import React from "react";
import { PieChart, Props as PieChartProps } from "app/charts/PieChart/PieChart";
import "./style.scss";

interface Props extends PieChartProps {
    className?: string;
    children: React.ReactNode;
}

/**
 * This renders a pie chart with content inside. The content will be shown horizontally and vertically centered.
 */
export const PieChartWithContent = ({ className, values, children }: Props) => (
    <div className={`pieChartWithContent${className ? " " + className : ""}`}>
        <div>{children}</div>
        <PieChart values={values} />
    </div>
);
